module.exports = __webpack_public_path__ + "static/outter-0cc7a63b3571dc78e3d0f760a733e66a.png";